import { OptionType } from '@insurancemenu/imenu-components-lib/dist/types/Select';
import { DefaultFormFields, FormControl, FormController } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { makeAutoObservable } from 'mobx';
import { Agent } from 'types/idTrackerService';

export interface SelectAgentFormFields extends DefaultFormFields {
  agentOfRecord: FormControl<string>;
}

export class SelectAgentDelegate {
  private _agentOptions: OptionType[] = [];
  private _formIsBlocked = false;

  public form = new FormController<SelectAgentFormFields>({
    agentOfRecord: new FormControl<string>(''),
  });

  public get agentOptions(): OptionType[] {
    return [...this._agentOptions];
  }

  public get selectedAgentId(): string | undefined {
    return this.form.fields.agentOfRecord.value;
  }

  public get isFormBlocked(): boolean {
    return this._formIsBlocked;
  }

  public get isFormValid(): boolean {
    return this.form.basicFieldsValidationsPassed && !this._formIsBlocked;
  }

  public get selectedAgentNumber(): string | undefined {
    return this.form.fields.agentOfRecord.value === 'other' ? '-1' : this.form.fields.agentOfRecord.value;
  }

  public setAgents(agentOptions: Agent[]): void {
    this._agentOptions = agentOptions.map((agent) => ({
      value: agent.agentNumber,
      label: agent.agentNumber === '-1' ? 'Other (New Agent)' : `${agent.firstName} ${agent.lastName}`,
    }));
  }

  public populateAgent(agent: Agent): void {
    this.form.populateFields({
      agentOfRecord: agent.agentNumber,
    });
  }

  public setFormIsBlocked(isBlocked: boolean): void {
    this._formIsBlocked = isBlocked;
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }
}
